import { render } from "./Vnud-Pricing.vue?vue&type=template&id=3642f7b4"
import script from "./Vnud-Pricing.vue?vue&type=script&lang=js"
export * from "./Vnud-Pricing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Projetos\\WIP\\Reorganiza\\Leadcenter\\Dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__